<template>
  <div class="app">
    <div class="app_con">
      <img class="logo" src="./assets/images/logo.png" alt="">
      <div class="main">
        <img class="main-image" src="./assets/images/main.png" alt="">
        <div class="con_r">
          <Main
            v-if="isLogin"
            :account="activeAccount"
            :chain-supported="isSupportedChain"
            @account-change="handleWalletConnected"
            @switch-network="handleSwitchNetwork"
          />
          <login v-else @loginSuccess="handleWalletConnected" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Login from './views/Login.vue'
import Main from './views/Main.vue'
import {
  clearStoredWalletAccount,
  ensureTargetChain,
  getActiveWalletAccount,
  getCurrentChainId,
  isTargetChain,
  setStoredWalletAccount,
  subscribeWalletEvents
} from '@/utils/walletRuntime'

export default {
  components: {
    Login, Main
  },
  data() {
    return {
      isLogin: false,
      activeAccount: null,
      isSupportedChain: true,
      stopWalletSubscription: null
    }
  },
  async created() {
    await this.initializeWalletRuntime()
    this.bindWalletEvents()
  },
  beforeDestroy() {
    if (typeof this.stopWalletSubscription === 'function') {
      this.stopWalletSubscription()
    }
  },
  methods: {
    async initializeWalletRuntime() {
      const [account, chainId] = await Promise.all([
        getActiveWalletAccount(),
        getCurrentChainId()
      ])

      this.updateAccountState(account)
      this.isSupportedChain = chainId ? isTargetChain(chainId) : true
    },
    bindWalletEvents() {
      this.stopWalletSubscription = subscribeWalletEvents({
        onAccountsChanged: accounts => {
          this.updateAccountState(accounts[0] || null)
        },
        onChainChanged: chainId => {
          this.isSupportedChain = isTargetChain(chainId)
          if (!this.isSupportedChain) {
            this.$message.error('Please switch to the correct network')
          }
        }
      })
    },
    updateAccountState(account) {
      this.activeAccount = account
      this.isLogin = Boolean(account)

      if (account) {
        setStoredWalletAccount(account)
      } else {
        clearStoredWalletAccount()
      }
    },
    async handleWalletConnected(account) {
      const activeAccount = account || (await getActiveWalletAccount())
      this.updateAccountState(activeAccount)
      const chainId = await getCurrentChainId()
      this.isSupportedChain = chainId ? isTargetChain(chainId) : true
    },
    async handleSwitchNetwork() {
      try {
        const chainId = await ensureTargetChain()
        this.isSupportedChain = isTargetChain(chainId)
      } catch (error) {
        this.$message.error(
          error && error.message ? error.message : 'Failed to switch network'
        )
      }
    }
  }
}
</script>

<style scoped>
.app {
  width: 100vw;
  height: 100vh;
  background: url('./assets/images/bg.png') no-repeat;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.app_con {
  /* width: 13.88rem; */
  height: 7.80rem;
  background: #FFFFFF;
  box-shadow: 0px 4px 20px 0px rgba(204, 204, 204, 0.35);
  border-radius: 0.24rem;
  padding: 0.2rem 0.4rem;
  box-sizing: border-box;
  overflow: auto;
}

.logo {
  height: 0.48rem;
}

.main {
  align-items: center;
  height: 90%;
  /* margin-top:0.76rem; */
  display: flex;
}

.main-image {
  width: 4rem;
  max-width: 100%;
  height: auto;
  object-fit: contain;
  margin-top: 0.4rem;
}

.con_r {
  flex: 1;
}
</style>
